<template>
  <div id="hmsChart-app">
    <div style="position: absolute; z-index: 1;">
      <div id="top-container">
        <div class="filter-title">
          Company Type
          <label for="office" class="filter-title filter-subtitle hasTooltipDetail" @mouseenter="showTooltip($event)" @mouseleave="closeTooltip()" data-tooltipContent = "An office with desk work only.">
          <input type="radio" @click="removeFocus($event)" id="office" value="office" v-model="coTypeFilter"/>Office</label> 
          <label for="retail" class="filter-title filter-subtitle hasTooltipDetail" @mouseenter="showTooltip($event)" @mouseleave="closeTooltip()" data-tooltipContent = "Retail, Manufacturing, Electricity, Gas, Water, Heat supply, Hotel, Golf course, Automobile repair, Telecommunications, Wholesale, Furniture, Fuel, Machine repair"><input type="radio"  @click="removeFocus($event)" id="retail" value="retail" v-model="coTypeFilter"/>Retail</label>
          <label for="construction" class="filter-title filter-subtitle hasTooltipDetail" @mouseenter="showTooltip($event)" @mouseleave="closeTooltip()" data-tooltipContent ="Construction, Forestry, Mining, Transportation, Cleaning"><input type="radio"  @click="removeFocus($event)" id="construction" value="construction" v-model="coTypeFilter"/>Construction</label>
        </div>
      </div>
      <div id="description">
        Hover over the chart to highlight, click to select.
      </div>
      <div id="main-container" v-if="isReady">
        <div class="gridlines">
          <div class="heading" style="width: 40px; margin-top: 106px; padding-left: 10px;">Employees</div>
          <div style="width: 20px"> 
            <template v-for="(size, i) in sizes" :key="i">
              <div class="line" :class="{bold: size === 50 || size ===1}"
                :style="'top:' + getGridLineHeight(i) + 'px; width: 800px;'">
                <span :class="{ 'text-highlight': active == sizes.length -1 - i }">{{ size === 1? 0 : size }}</span>
              </div>
              <div class="line" :class="{bold: size === 50 || size ===1}"
                :style="'top:' + getGridLineHeight(i) + 'px; width: 578px; left: 912px;'">
                <span>&nbsp;</span>
              </div>
            </template>
          </div>
        </div>
        
        <div style="margin-right: 50px;">
          <div class="title">Team</div>
          <div class="container">

            <div :class="{ category: true, border: true}">
              <div class="heading">Doctors</div>
              <div class="column">
                <div style="width: 56px;">
                  <div class="label">
                    Health Clinic
                  </div>
                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div v-if="coTypeFilter === 'office'" class="icons-container-row" :class="{ center: item[sizes[i]].office.healthClinic == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].office.healthClinic" :key="n">
                        <Person class="iconblur img-person" type="hlthClinic" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'retail'"  class="icons-container-row" :class="{ center: item[sizes[i]].retail.healthClinic == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].retail.healthClinic" :key="n">
                        <Person class="iconblur img-person" type="hlthClinic" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'construction'"  class="icons-container-row" :class="{ center: item[sizes[i]].construction.healthClinic == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].construction.healthClinic" :key="n">
                        <Person class="iconblur img-person" type="hlthClinic" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="line-thick">
                  <div class="label"
                    @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                    @mouseleave="closeTooltip()"
                    :data-tooltipHeader="tooltipData.indusPhysician.header" 
                    :data-tooltipContent="tooltipData.indusPhysician.content"
                  >
                    Industrial <br>Physician
                  </div>
                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div v-if="coTypeFilter === 'office'" class="icons-container-row" :class="{ center: item[sizes[i]].office.nbIndusPhysician == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].office.nbIndusPhysician" :key="n">
                        <Person class="iconblur img-person" type="indusPhysician" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'retail'"  class="icons-container-row" :class="{ center: item[sizes[i]].retail.nbIndusPhysician == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].retail.nbIndusPhysician" :key="n">
                        <Person class="iconblur img-person" type="indusPhysician" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'construction'" class="icons-container-row" :class="{ center: item[sizes[i]].construction.nbIndusPhysician == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].construction.nbIndusPhysician" :key="n">
                        <Person class="iconblur img-person" type="indusPhysician" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div :class="{ category: true, border: true}">
              <div class="heading">Employee with Certification</div>
              <div class="column">
                <div> <!-- Promoter  -->
                  <div class="label label-span2">Promoter</div>
                  <div class="column">
                    <div> <!-- Promoter  -->
                      <div class="label label-short" style="width: 48px;"
                        @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                        @mouseleave="closeTooltip()"
                        :data-tooltipHeader="tooltipData.hlthPromoter.header" 
                        :data-tooltipContent="tooltipData.hlthPromoter.content"
                      >
                        Health
                      </div>
                      <div class="icons-container" v-for="(item, i) in data" :key="i">
                        <div v-if="coTypeFilter === 'office'" class="icons-container-row" :class="{ center: item[sizes[i]].office.nbHlthPromoter == 1 }">
                          <div class="item">
                            <Person class="iconblur img-person" type="hlthPromoter" v-if="item[sizes[i]].office.nbHlthPromoter > 0" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                        </div>
                        <div v-if="coTypeFilter === 'retail'" class="icons-container-row" :class="{ center: item[sizes[i]].retail.nbHlthPromoter == 1 }">
                          <div class="item">
                            <Person class="iconblur img-person" type="hlthPromoter" v-if="item[sizes[i]].retail.nbHlthPromoter > 0" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                        </div>
                        <div v-if=" coTypeFilter === 'construction'" class="icons-container-row" :class="{ center: item[sizes[i]].construction.nbHlthPromoter == 1 }">
                          <div class="item">
                            <Person class="iconblur img-person" type="hlthPromoter" v-if="item[sizes[i]].construction.nbHlthPromoter > 0" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="healthSfty line-thin">
                      <div class="label label-short" 
                        @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                        @mouseleave="closeTooltip()"
                        :data-tooltipHeader="tooltipData.hlthSftyPromoter.header" 
                        :data-tooltipContent="tooltipData.hlthSftyPromoter.content"
                      >
                        Health & Safety
                      </div>
                      <div class="icons-container" v-for="(item, i) in data" :key="i">
                        <div v-if="coTypeFilter === 'office'" class="icons-container-row" :class="{ center: item[sizes[i]].office.nbHlthSftyPromoter == 1 }">
                          <div class="item">
                            <Person class="iconblur img-person" type="hlthSftyPromoter" v-if="item[sizes[i]].office.nbHlthSftyPromoter > 0" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                        </div>
                        <div v-if="coTypeFilter === 'retail'" class="icons-container-row" :class="{ center: item[sizes[i]].retail.nbHlthSftyPromoter == 1 }">
                          <div class="item">
                            <Person class="iconblur img-person" type="hlthSftyPromoter" v-if="item[sizes[i]].retail.nbHlthSftyPromoter > 0" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                        </div>
                        <div v-if="coTypeFilter === 'construction'" class="icons-container-row" :class="{ center: item[sizes[i]].construction.nbHlthSftyPromoter == 1 }">
                          <div class="item">
                            <Person class="iconblur img-person" type="hlthSftyPromoter" v-if="item[sizes[i]].construction.nbHlthSftyPromoter > 0" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                        </div> 
                      </div>
                    </div>
                  </div>
                </div>
                <div class="healthOfficer line-thick" style="width: 140px;">
                  <div class="label" style="width: 140px;"
                    @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                    @mouseleave="closeTooltip()"
                    :data-tooltipHeader="tooltipData.hlthOfficer.header" 
                    :data-tooltipContent="tooltipData.hlthOfficer.content"
                  >
                    Health Officer
                  </div>
                    <div>
                      <div class="icons-container" v-for="(item, i) in data" :key="i">
                        <div class="icons-container-row">
                          <div class="item" v-for="n in item[sizes[i]].office.nbHlthOfficer" :key="n">
                            <Person class="iconblur img-person" type="hlthOfficer" v-if="coTypeFilter === 'office'" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                          <div class="item" v-for="n in item[sizes[i]].retail.nbHlthOfficer" :key="n">
                            <Person class="iconblur img-person" type="hlthOfficer" v-if="coTypeFilter === 'retail'" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                          <div class="item" v-for="n in item[sizes[i]].construction.nbHlthOfficer" :key="n">
                            <Person class="iconblur img-person" type="hlthOfficer" v-if="coTypeFilter === 'construction'" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>

                        </div>
                      </div>
                    </div>
                  
                </div>
                <div class="sftyOfficer line-thick">
                  <div class="label" style="width: 48px;">
                    Safety Officer
                  </div>

                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div v-if="coTypeFilter === 'office'" class="icons-container-row" :class="{ center: item[sizes[i]].office.nbSftyOfficer == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].office.nbSftyOfficer" :key="n">
                        <Person class="iconblur img-person" type="sftyOfficer" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'retail'"  class="icons-container-row" :class="{ center: item[sizes[i]].retail.nbSftyOfficer == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].retail.nbSftyOfficer" :key="n">
                        <Person class="iconblur img-person" type="sftyOfficer" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'construction'" class="icons-container-row" :class="{ center: item[sizes[i]].construction.nbSftyOfficer == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].construction.nbSftyOfficer" :key="n">
                        <Person class="iconblur img-person" type="sftyOfficer" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                  </div>
                </div>    
              </div>
            </div>

            <div :class="{ category: true, border: true}">
              <div class="heading">Employees</div>
              <div class="column">
                <div style="width: 190px;">
                  <div class="label" style="min-width:190px">
                    Employee <br>Representatives
                  </div>
                    <div>
                      <div class="icons-container" v-for="(item, i) in data" :key="i">
                        <div class="icons-container-row">
                          <div class="item" v-for="n in item[sizes[i]].office.nbEmplyRepresentative" :key="n" >
                            <Person class="iconblur img-person" type="emplyRepresentative" v-if="coTypeFilter === 'office'" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                          <div class="item" v-for="n in item[sizes[i]].retail.nbEmplyRepresentative" :key="n" >
                            <Person class="iconblur img-person" type="emplyRepresentative" v-if="coTypeFilter === 'retail'" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                          <div class="item" v-for="n in item[sizes[i]].construction.nbEmplyRepresentative" :key="n" >
                            <Person class="iconblur img-person" type="emplyRepresentative" v-if="coTypeFilter === 'construction'" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  
                </div>
                <div class="hlthSftyMngr line-thick">
                  <div class="label">
                    Health & Safety Manager
                  </div>
                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div v-if="coTypeFilter === 'office'" class="icons-container-row" :class="{ center: item[sizes[i]].office.nbHlthSftyManager == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].office.nbHlthSftyManager" :key="n">
                        <Person class="iconblur img-person" type="hlthSftyManager" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'retail'" class="icons-container-row" :class="{ center: item[sizes[i]].retail.nbHlthSftyManager == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].retail.nbHlthSftyManager" :key="n">
                        <Person class="iconblur img-person" type="hlthSftyManager" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'construction'" class="icons-container-row" :class="{ center: item[sizes[i]].construction.nbHlthSftyManager == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].construction.nbHlthSftyManager" :key="n">
                        <Person class="iconblur img-person" type="hlthSftyManager" :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                  </div>
                </div>    
                <div class="wrksplcMngr line-thick">
                  <div class="label">
                    Company Management
                  </div>
                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div v-if="coTypeFilter === 'office'" class="icons-container-row" :class="{ center: item[sizes[i]].office.nbCmpnyMgmt == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].office.nbCmpnyMgmt" :key="n">
                        <Person class="iconblur img-person" type="wrkplcManager"  :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'retail'" class="icons-container-row" :class="{ center: item[sizes[i]].retail.nbCmpnyMgmt == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].retail.nbCmpnyMgmt" :key="n">
                        <Person class="iconblur img-person" type="wrkplcManager"  :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                    <div v-if="coTypeFilter === 'construction'" class="icons-container-row" :class="{ center: item[sizes[i]].construction.nbCmpnyMgmt == 1 }">
                      <div class="item" v-for="n in item[sizes[i]].construction.nbCmpnyMgmt" :key="n">
                        <Person class="iconblur img-person" type="wrkplcManager"  :class="{ 'iconbright': active == sizes.length - 1 - i }"/>
                      </div>
                    </div>
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>

        <div class="activities">
          <div class="title">Activities</div>
          <div class="container">
            <div class="weekly-column " :class="{ category: true, border: true}">
              <div class="heading">Weekly</div>
              <div class="label" 
                @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                @mouseleave="closeTooltip()"
                :data-tooltipHeader="tooltipData.wklyWrkPlcInspect.header" 
                :data-tooltipContent="tooltipData.wklyWrkPlcInspect.content"
              >
                Workpl Inspect.
              </div>

              <div class="icons-container" v-for="(item, i) in data" :key="i">
                <div class="item">
                  <Square v-if="item[sizes[i]].office.needsWklyWrkPlcInspect && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                </div>
                <div>
                  <Square v-if="item[sizes[i]].retail.needsWklyWrkPlcInspect && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                </div>
                <div>
                  <Square v-if="item[sizes[i]].construction.needsWklyWrkPlcInspect && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                </div>
              </div>
            </div>

            <div class="monthly-column" :class="{ category: true, border: true}">
              <div class="heading">Monthly</div>
              <div id="monthly">
                <div class="wrkplcInsp">
                  <div class="label"
                    @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                    @mouseleave="closeTooltip()"
                    :data-tooltipHeader="tooltipData.mnthlyWrkPlcInspect.header" 
                    :data-tooltipContent="tooltipData.mnthlyWrkPlcInspect.content"
                  >
                    Workpl Inspect.</div>

                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div class="item">
                      <Square v-if="item[sizes[i]].office.needsMnthlyWrkPlcInspect && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].retail.needsMnthlyWrkPlcInspect && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].construction.needsMnthlyWrkPlcInspect && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                  </div>
                </div>
                <div class="cmmttMtng">
                  <div class="label label-span2">Committee Meeting</div>
                  <div class="column line-thick">
                    <div class="health">
                      <div class="label label-short"
                        @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                        @mouseleave="closeTooltip()"
                        :data-tooltipHeader="tooltipData.mnthlyHlthCmmttMeeting.header" 
                        :data-tooltipContent="tooltipData.mnthlyHlthCmmttMeeting.content"
                      >
                        Health
                      </div>
                      <div class="icons-container" v-for="(item, i) in data" :key="i">
                        <div class="item">
                          <Square v-if="item[sizes[i]].office.needsMnthlyHlthCmmttMeeting && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].retail.needsMnthlyHlthCmmttMeeting && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].construction.needsMnthlyHlthCmmttMeeting && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                      </div>
                    </div>
                    <div class="healthSfty line-thin">
                      <div class="label label-short"
                        @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                        @mouseleave="closeTooltip()"
                        :data-tooltipHeader="tooltipData.mnthlyHlthSftyCmmttMeeting.header" 
                        :data-tooltipContent="tooltipData.mnthlyHlthSftyCmmttMeeting.content"
                      >
                        Health & Safety
                      </div>
                      <div
                        class="icons-container" v-for="(item, i) in data" :key="i">
                        <div class="item">
                          <Square v-if="item[sizes[i]].office.needsMnthlyHlthSftyCmmttMeeting && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].retail.needsMnthlyHlthSftyCmmttMeeting && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].construction.needsMnthlyHlthSftyCmmttMeeting && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="annual-column" :class="{ category: true, border: true}">
              <div class="heading">Annual</div>
              <div class="annual column">
                <div class="annual">
                  <div class="label label-span2"
                    @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                    @mouseleave="closeTooltip()"
                    :data-tooltipHeader="tooltipData.annlHlthCheck.header" 
                    :data-tooltipContent="tooltipData.annlHlthCheck.content"
                  >
                    Health Check
                  </div>
                  <div class="column">
                    <div class="health">
                      <div class="label label-short">Exam</div>
                      <div class="icons-container" v-for="(item, i) in data" :key="i">
                        <div class="item">
                          <Square v-if="item[sizes[i]].office.needsAnnlHlthChckExam && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].retail.needsAnnlHlthChckExam && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].construction.needsAnnlHlthChckExam && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                      </div>
                    </div>
                    <div class="healthSfty line-thin">
                      <div class="label label-short" >
                        Admin
                      </div>
                      <div
                        class="icons-container" v-for="(item, i) in data" :key="i">
                        <div class="item">
                          <Square v-if="item[sizes[i]].office.needsAnnlHlthChckAdmin && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].retail.needsAnnlHlthChckAdmin && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                        <div>
                          <Square v-if=" item[sizes[i]].construction.needsAnnlHlthChckAdmin && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="stressCheck line-thick">
                  <div class="label"
                    @mouseenter="showTooltip($event, false, true), lineTooltip($event)"
                    @mouseleave="closeTooltip()"
                    :data-tooltipHeader="tooltipData.annlStrssCheck.header" 
                    :data-tooltipContent="tooltipData.annlStrssCheck.content"
                  >
                    Stress Check
                  </div>

                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div class="item">
                      <Square v-if="item[sizes[i]].office.needsAnnlStrssCheck && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].retail.needsAnnlStrssCheck && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].construction.needsAnnlStrssCheck && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="adhoc-column" :class="{ category: true, border: true}">
              <div class="heading">Ad-hoc</div>
              <div class="adhoc column">

                <div class="prsnlRpt">
                  <div class="label">Personnel Reporting</div>

                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div class="item">
                      <Square v-if="item[sizes[i]].office.needsAdhocPrsnlReporting && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].retail.needsAdhocPrsnlReporting && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].construction.needsAdhocPrsnlReporting && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                  </div>
                </div>

                <div class="incidentRpt line-thick">
                  <div class="label">Incident Reporting</div>

                  <div class="icons-container" v-for="(item, i) in data" :key="i">
                    <div class="item">
                      <Square v-if="item[sizes[i]].office.needsAdhocIncdntReporting && coTypeFilter === 'office'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].retail.needsAdhocIncdntReporting && coTypeFilter === 'retail'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                    <div>
                      <Square v-if="item[sizes[i]].construction.needsAdhocIncdntReporting && coTypeFilter === 'construction'" :class="{ 'square-highlight': active == sizes.length - 1 - i }"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>
    </div>
    <Tooltip style="z-index: 2;"
        v-if="tooltipIsOn"
        :tooltipPosition="tooltip.position"
        :header="tooltip.header"
        :content="tooltip.content"
    >
    </Tooltip>
    <!-- line between label and tooltip -->
    <svg id="svg" v-if="tooltipIsOn" :viewBox="'0 0 ' + viewBoxWidth + ' ' + viewBoxHeight" xmlns="http://www.w3.org/2000/svg" :style="'position: absolute; z-index: 2; background-color: #91c5ff; left: ' + xElement + 'px; top: ' + yElement + 'px; width: 2px; height: ' + (yTooltip - yElement) + 'px;'"></svg>

    <!--rolling over rows-->
    <template v-for="(item, i) in sizes" :key="i">
      <div class="rolledover-row" @mouseenter="highlightRow(i)" :style="{ top: getRowHeight(i) + 'px', width: '40px', left: '45px'}" @click="selectRow(i)">
      </div>
      <div class="rolledover-row" @mouseenter="highlightRow(i)" :style="{ top: getRowHeight(i) + 'px', width: '762px', left: '92px'}" :class="{'row-highlight': selected == i, 'border-right-none': selected == i }" @click="selectRow(i)">
      </div>
      <div class="rolledover-row" @mouseenter="highlightRow(i)" :style="{ top: getRowHeight(i) + 'px', width: '72px', left: '850px' }" :class="{'row-highlight' : selected == i, 'dash-highlight': selected == i }" @click="selectRow(i)">
      </div>
      <div class="rolledover-row rightbox" @mouseenter="highlightRow(i)" :style="{ top: getRowHeight(i) + 'px', width: '582px', left: '922px'}" :class="{'row-highlight' : selected == i}" @click="selectRow(i)">
      </div>
    </template>

  </div>
</template>

<script setup>
import Square from "@/components/IconSquare1.vue";
import Person from "@/components/IconPerson.vue";
import Tooltip from '@/components/Tooltip.vue';
import { ref } from "vue";
import { useRequirements } from "@/composable/Requirements.js";
import { useTooltip } from '@/composable/Tooltip.js';
import tData from '@/json/tooltipData.json';

//let size = ref(10);
let sizes = ref([3000, 2000, 1000, 500, 300, 200, 100, 50, 10, 1]);
// let sizesForSlider = ref(JSON.parse(JSON.stringify(sizes.value)).reverse()); // reverse of sizes array deep 
let coTypes = ["office", "construction", "retail"];
let coSize = ref();
let type = ref();

let active = ref(2);

const tooltipData = ref(tData[0])

let isReady = ref(false)
const data = ref([]);

sizes.value.forEach((size) => {
  let res = { [size]: {} };
  coTypes.forEach((coType) => {
    coSize.value = size; // composible expect to receive ref()
    type.value = coType;

    const {
      needsWklyWrkPlcInspect,
      needsMnthlyWrkPlcInspect,
      needsMnthlyHlthCmmttMeeting,
      needsMnthlyHlthSftyCmmttMeeting,
      needsAnnlHlthChckAdmin,
      needsAnnlHlthChckExam,
      needsAnnlStrssCheck,
      needsAdhocPrsnlReporting,
      needsAdhocIncdntReporting,
      healthClinic,
      nbIndusPhysician,
      nbHlthPromoter,
      nbHlthSftyPromoter,
      nbHlthOfficer,
      nbCmpnyMgmt,
      nbEmplyRepresentative,
      nbHlthSftyManager,
      nbSftyOfficer,
      needsHlthChckSummary,
    } = useRequirements(coSize, type);

    res[size][coType] = {
      needsWklyWrkPlcInspect: needsWklyWrkPlcInspect.value,
      needsMnthlyWrkPlcInspect: needsMnthlyWrkPlcInspect.value,
      needsMnthlyHlthCmmttMeeting: needsMnthlyHlthCmmttMeeting.value,
      needsMnthlyHlthSftyCmmttMeeting: needsMnthlyHlthSftyCmmttMeeting.value,
      needsAnnlHlthChckAdmin: needsAnnlHlthChckAdmin.value,
      needsAnnlHlthChckExam: needsAnnlHlthChckExam.value,
      needsAnnlStrssCheck: needsAnnlStrssCheck.value,
      needsAdhocPrsnlReporting: needsAdhocPrsnlReporting.value,
      needsAdhocIncdntReporting: needsAdhocIncdntReporting.value,
      nbIndusPhysician: nbIndusPhysician.value,
      nbHlthPromoter: nbHlthPromoter.value,
      nbHlthSftyPromoter: nbHlthSftyPromoter.value,
      healthClinic: healthClinic.value,
      nbHlthOfficer: nbHlthOfficer.value,
      nbCmpnyMgmt: nbCmpnyMgmt.value,
      nbEmplyRepresentative: nbEmplyRepresentative.value,
      nbHlthSftyManager: nbHlthSftyManager.value,
      nbSftyOfficer: nbSftyOfficer.value,
      needsHlthChckSummary: needsHlthChckSummary.value,
    };
  });
  data.value.push(res);
  res = {};
});

isReady.value = true

function getGridLineHeight (m) {
    let top = 237
    let iconBoxHeight = 32
    let marginBottom = 32
    if (m === 0){
      return top
    }
      return top + m * (iconBoxHeight + marginBottom)
}

function getRowHeight(m) {
  let top = 810;
  return m === 0 ? top : ( top - m*64);
}
// filter 
const coTypeFilter = ref('office');

function removeFocus(e) {
  e.target.blur()
  // animationBox.value.focus()
}
  
// Tooltip

const {
  tooltipIsOn,
  tooltip,
  showTooltip,
  closeTooltip
} = useTooltip(380)

function highlightRow(i) {
  active.value = i;
}

const selected = ref(null)
function selectRow(i) {
  const rollovers = document.getElementsByClassName('rolledover-row');
  if (selected.value == i) { // if already selected, unselect
    selected.value = null;
  } else { // if not selected, select
    selected.value = i;
  }   

  Array.from(rollovers).forEach((element, n) => {
    if (n !== i*4 && n !== i*4+1 && n !== i*4+2 && n !== i*4+3)
    // each row has 4 rollover elements; we find unselected rows by checking if the element is not one of the 4 elements in the row
    {
      if (selected.value == i) { 
        element.style.pointerEvents = 'none'; 
      } else { 
        element.style.pointerEvents = 'auto';
      }   
    }
  });
}

let xElement = ref(0)
let yElement = ref(0)
let xTooltip = ref(0)
let yTooltip = ref(0)
const viewBoxWidth = window.innerWidth
const viewBoxHeight = window.innerHeight
function lineTooltip(e) {
  const xMargin = e.target.getBoundingClientRect().width/7*3 // to horizontally position the line between the label and the tooltip
  const elementHeight = e.target.getBoundingClientRect().height
  xElement.value = e.target.getBoundingClientRect().x + xMargin
  yElement.value = e.target.getBoundingClientRect().y + elementHeight
  const xTooltipString = tooltip.value.position.left
  xTooltip.value = parseInt(xTooltipString.substring(0, xTooltipString.length - 2)) + xMargin
  const yTooltipString = tooltip.value.position.top
  yTooltip.value = parseInt(yTooltipString.substring(0, yTooltipString.length - 2))
  console.log(xElement.value, yElement.value, xTooltip.value, yTooltip.value)
}
</script>

<style scoped>

* { box-sizing: border-box;}
.border-red { border: 1px solid red; }  /* for debugging */

#hmsChart-app {
  margin: 0;
  padding: 0;
  font-family: Calibri, 'Trebuchet MS', sans-serif;
  font-size: 14px;
}

#top-container {
  display: flex; 
  justify-content: space-between; 
  position: absolute; 
  width: 440px; 
  z-index: 1;
  top: 4px; 
  left: 712px;
}
#description {
  position: absolute;
  width: 440px;
  margin: 20px;
  color: #f7f6e9;
}
#main-container {
  display: flex;
  position: absolute;
  gap: 20px;
  padding: 67px 0 10px 0;
  margin-top: 32px;
}

.gridlines {
  display:flex
}
.line {
  position: absolute; 
  border-bottom: 0.1px solid #958e00;
  color: #f3f2e4;
  font-weight: bold;
}
.line.bold{
  border-bottom: 3px solid #958e00;
}

.title {
  color: #91c5ff;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.heading {
  color: #f3f2e4;
  margin: auto;
  width: 100%;
  text-align: center;
  font-weight: bold;
}

.label {
  background-color: #f7f6e9;
  width: 60px; 
  height: 60px;
  border: 2px solid #958e00;
  border-radius: 5px;
  overflow-wrap: break-word;
  margin-bottom: 16px;
  text-align: center;
  color: #726E2E;
  font-size: 13.5px;
  font-weight: bold; 
}

.label-short { height: 40px; }

.label:hover {
  background-color: #91c5ff;
  cursor: pointer;
}

.label-span2 {
  width: 100%;
  height: 20px;
  margin-bottom: 0;
}

.container {
  margin-top: 4px;
  display: flex;
}
.icons-container {
  height:32px;
  margin-bottom: 32px;
}
.icons-container-row {
  display: flex;
  padding: 0 10px;
  margin-left: -10px;
}

.rolledover-row {
  position: absolute;
  height: 64px;
  cursor: pointer;
  z-index: 1;
}
.iconblur {
  opacity: 0.5;
}
.iconbright {
  opacity: 1;
}
.row-highlight { 
  border: 4px solid #c8c58c;  
  z-index: 1;
}
.border-none { border: none; }

.border-right-none { border-right: none; }

.dash-highlight { 
  border-style: dashed;
  border-left: none;
  border-right: none;
}

.square-highlight { background-color: #7191b3; }

.text-highlight { 
  color: #91c5ff;
  font-weight: bold;
}

.rightbox {
  border-left: none;
}

.item {
  padding-top: 2px;
}
.row {
  display: flex;
  flex-direction: column;
}
.column {
  display: flex;
}

.category {
  margin: 1px;
  padding: 2px;
}
.border {
  box-shadow: 0 0 0 2px #7191b3;
  border-radius: 5px;
}

.line-thin {
  border-left: 0.1px solid #726E2E;
}

.line-thick {
  border-left: 3px solid #726E2E;
  margin-left: 1px;
  padding-left: 1px;
}

#monthly {
  display: flex;
}
.img-person {
  margin-right: -10px;
  margin-top: 5px;
}

.center {
  justify-content: center;
}
.filter-title {
  font-weight: bold;
  font-size: 17px;
  color: #F9F9F1;
}

.filter-subtitle {
  display: block;
  margin-left: 8px;
}

.filter-box {
  border: 2px solid #9F9900;
  border-radius: 5px;
  padding: 5px;
}

.hasTooltipDetail:hover {
  text-decoration: underline;
  cursor: pointer;
}
.tooltip-line {
  height: 20px;
  width: 5px;
  position: absolute;
  border-right: 3px solid #7191b3;
  top: 172px;
  margin-left: 10px;
  opacity: 0;
}
.showtooltipline {
  opacity: 1;
}
</style>
